import Vue from 'vue'
import Vuex from 'vuex'

// m模块化
import common from './store/common';
import newpage from './store/newPage';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    newpage
  }
  // state: {
  //   userInfo: {
  //     name: 'store',
  //     id: 1
  //   }
  // },
  // mutations: {

  // },
  // actions: {

  // }
})